<template>
  <div class="v-view swiper-view a-fadeIn" :style="{ height: span * 33.33 + '%' }">
    <div class="v-title">{{ title }}</div>

    <swiper v-if="list && list.length > 0" ref="orderSwiper" class="sv-swiper" :options="swiperOption">
      <swiper-slide class="sv-swiper-slide" v-for="(value, key) in list" :key="key" :data-index="key">
        <a v-if="value.LinkUrl && value.LinkUrl !== ''" :href="value.LinkUrl" target="_blank" rel="noopener noreferrer">
          <img class="sv-swiper-slide-item" :src="value.ImagePath" alt="">

        </a>
        <img v-else class="sv-swiper-slide-item" :src="value.ImagePath" alt="">
        <p class="TitileName">{{ value.TitileName }}</p>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ServicePhoto.vue',
  computed: {
    ...mapGetters(['cid']),
  },
  props: {
    span: {
      type: Number,
      default: 1,
    },
    title: {
      type: String,
      default: '居家服务动态',
    },
  },
  watch: {},
  data() {
    const vm = this
    return {
      dialogVisible: false,
      dataInterval: null,
      orderData: {},
      orderSwiper: null,
      photoSwiper: null,
      swiperData: [],
      swiperList: [],
      swiperOption: {
        direction: 'vertical',
        grabCursor: true,
        slidesPerView: 1,
        speed: 1000,
        loop: true,
        observer: true,
        observeParents: true,
        autoplay: true
        // autoplay: {
        //   delay: 1000,
        //   disableOnInteraction: false,
        // }
      },
      list: []
    }
  },
  created() { },
  mounted() {
    this.getPhoto(this.cid)
  },
  beforeDestroy() { },
  methods: {
    getPhoto(cid) {
      this.$api.getCompanyANPictureModuleList(cid).then((result) => {
        if (!result) return
        // console.log(result);
        result = result.map(item => {
          return {
            'LinkUrl': item.LinkUrl,
            'TitileName': item.TitileName,
            'ImagePath': process.env.VUE_APP_BASE_URL + item.ImagePath
          }
        })
        this.list = result
      }).catch((err) => {
        console.log(err);
      });
    }
  },
}
</script>

<style lang="scss" scoped>
.TitileName {
  width: 100%;
  position: absolute;
  bottom: 5px;
  left: 10px;
  right: 10px;
  background-color: rgba($color: #000000, $alpha: 0.7);
  z-index: 99;
  font-size: 16px;
  text-align: center;
  color: #fff;
  padding: 7px 0;
}

.swiper-view {
  .sv-nodata {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }

  .sv-swiper {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .sv-swiper-slide {
    display: flex;
    align-items: center;
    padding: 5px 10px;
    position: relative;

    img,
    a {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    +.sv-swiper-slide::before {
      content: '';
      position: absolute;
      top: -0.5px;
      width: 100%;
      height: 1px;
      background: url('../assets/images/bg_line.png') no-repeat center center/60% 100%;
    }

    &__avatar {
      display: inline-flex;
      flex-direction: column;
      align-items: center;
      flex: none;
      width: 50px;
      overflow: hidden;

      >img {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        border: 1px solid #0077fc;
      }

      >div {
        z-index: -1; // 解决IE隐藏失效问题
        width: auto;
        font-size: 12px;
        text-align: center;
        white-space: nowrap;
      }
    }

    &__info {
      flex: auto;
      // width: 350px;
      margin-left: 10px;
    }

    &__done {
      flex: none;
      width: 30px;
      height: 30px;
    }

    &__wrap {
      display: flex;
      align-items: center;
      width: 100%;
      font-size: 12px;
      color: #96d0fc;

      +.sv-swiper-slide__wrap {
        margin-top: 5px;
      }

      img {
        width: 15px;
        height: auto;
        margin-right: 5px;
      }

      span {
        @include text-ellipsis-single;
      }
    }

    &__time {
      display: inline-flex;
      align-items: center;

      span {
        width: 130px;
      }
    }

    &__address {
      display: inline-flex;
      align-items: center;

      span {
        width: 200px;
      }
    }

    &__desc {
      font-size: 14px;
      color: #fff;

      span {
        width: 350px;
      }
    }
  }
}</style>
